import { useCallback } from 'react';
import useWaApi from './axios/useWaApi';
import { WaProduct, WaProductDetails } from '../store/models/product/WaProduct';

function useWaProductRepo() {
  const { get } = useWaApi();

  const getProductsRequest = useCallback(
    async (customerId: string, branchCode: string, disasterId: string | null) => {
      try {
        return (
          (await get<WaProduct[]>('/api/wa/product', {
            params: { customerId, branchCode, disasterId },
          })) ?? []
        );
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    [get]
  );

  const getProductDetailsRequest = useCallback(
    async (
      branchCode: string,
      productNumber: string,
      disasterId: string | null
    ): Promise<WaProductDetails | null> => {
      try {
        return await get<WaProductDetails>('/api/wa/product/detail', {
          params: { branchCode, productNumber, disasterId },
        });
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    [get]
  );

  return { getProductsRequest, getProductDetailsRequest };
}

export default useWaProductRepo;
